<div class="md:flex rounded-2xl md:h-48 box-main box-responsive">
  <div
    class="flex justify-center items-center bg-rain bg-cover px-6 py-4 rounded-2.5xl md:w-1/3">
    <h3 class="flex font-bold text-base md:text-lg">
      <span class="mr-1 text-red">*</span> Protect your group outing
    </h3>
  </div>
  @if (showRainoutInfo()) {
    <!-- Rainout Info -->
    <div
      class="flex flex-wrap md:flex-nowrap justify-center md:justify-stretch md:items-center px-6 py-4 md:w-2/3">
      <div class="md:mr-4 mb-4 md:h-full md:overflow-y-auto">
        <p class="mb-1 font-bold">About</p>
        <p>
          The
          {{ configurationService.configuration.clientName }} offer group ticket
          buyers the opportunity to purchase Group Rainout Insurance (ROI) to
          protect against the weather-related postponements of games by the
          {{ configurationService.configuration.clientName }} or Major League
          Baseball. In the event your group ticket game is postponed due to
          weather-related reasons, you will be eligible for a full-refund (less
          the cost of ROI). Rainout Insurance may be purchased for 10 percent of
          the total ticket package price. For more information on Group Rainout
          Insurance please
          <a
            class="text-main-light underline"
            [href]="configurationService.configuration.rainoutInsuranceUrl"
            target="_blank"
            >click here</a
          >.
        </p>
      </div>
      <button
        class="my-2 border border-main-dark w-20 text-main-dark btn-white"
        (click)="showRainoutInfo.set(false)">
        Close
      </button>
    </div>
  } @else {
    <!-- Rainout Choose -->
    <div
      class="flex flex-wrap md:flex-nowrap justify-center md:justify-start md:items-center px-6 py-4 md:w-2/3">
      <div class="mx-8 md:mx-0 md:mr-4 mb-4 md:mb-0 md:text-left text-center">
        @if (
          bypassCheckoutActive || eventDate() - nowDate > deadlineInMilliseconds
        ) {
          <h4 class="mb-2 font-normal text-sm md:text-base">
            Would you like to add Rainout Insurance to protect your outing?
          </h4>
        }
        @if (
          bypassCheckoutActive || eventDate() - nowDate > deadlineInMilliseconds
        ) {
          <div class="flex justify-center md:justify-stretch items-center">
            <label for="yes" class="mr-6 ml-2">
              <input
                type="radio"
                name="rain-out"
                id="yes"
                [value]="true"
                [(ngModel)]="
                  transaction()!.transaction.tdcTransaction!.hasInsuranceRainout
                "
                (ngModelChange)="onRainoutChange($event)" />
              Yes</label
            >

            <label for="no" class="ml-2">
              <input
                type="radio"
                name="rain-out"
                id="no"
                [value]="false"
                [(ngModel)]="
                  transaction()!.transaction.tdcTransaction!.hasInsuranceRainout
                "
                (ngModelChange)="onRainoutChange($event)" />
              No</label
            >
          </div>
        } @else {
          <h5 class="font-normal text-gray-400">
            Rainout Insurance is only available 21+ days before the game.
          </h5>
        }
      </div>
      <button
        class="bg-main-dark my-2 border border-white w-20 btn-main"
        (click)="showRainoutInfo.set(true)">
        +Info
      </button>
    </div>
  }
</div>
